import { enqueueSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { refreshAadeData } from "./gateway";

export default function useGetRefreshAadeData() {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: refreshAadeData,
    onSuccess: async () => {
      enqueueSnackbar(t("Επιτυχής Ενημέρωση Στοιχείων απο ΑΑΔΕ"), {
        variant: "success",
      });

      await queryClient.invalidateQueries("subcase_diff");
    },
  });
}
